<template>
  <b-container>
    <b-row class="vh-100 text-center" align-v="center">
      <b-col>
        <div class="spinner-border" role="status">
          <span class="sr-only">.</span>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'Loading',
}
</script>

<style scoped>

</style>
